import React, { memo } from 'react';
import { Route } from 'react-router-dom';
import UserProfileView from 'containers/UserProfile/UserProfileView';
function UserProfile({ url }) {
    return (React.createElement(Route, { exact: true, path: `${url}` },
        React.createElement(UserProfileView, null)));
}
export default memo(UserProfile);
